import { render, staticRenderFns } from "./ReportRenderer.vue?vue&type=template&id=08a45266&"
import script from "./ReportRenderer.vue?vue&type=script&lang=js&"
export * from "./ReportRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports